<div class="container" [class.success]="isSuccess">
  <div style="width: 50px; height: 50px">
    <mat-icon svgIcon="bringliesel-icon" class="bringliesel-icon"></mat-icon>
  </div>
  <div class="snackbar-text" [innerHTML]="data?.message"></div>
  <div class="snackbar-icon">
    <mat-icon *ngIf="isSuccess" class="check-icon">check</mat-icon>
    <mat-icon
      *ngIf="!isSuccess"
      class="error-icon"
      svgIcon="error-icon"></mat-icon>
  </div>
</div>
